declare const __APP_RELEASE_VERSION__: string | undefined;

/**
 * The newest release this dashboard build contains (`v4.17.3`), read at build time from the
 * release files in the tree being built (see vite.config.ts). It is sent as `upToVersion` so the
 * What's new log never announces a release whose frontend this tab does not have: the backend
 * rolls out first. Undefined (no files, tests) means no cap.
 */
export const APP_RELEASE_VERSION: string | undefined =
  typeof __APP_RELEASE_VERSION__ === 'string' && __APP_RELEASE_VERSION__
    ? __APP_RELEASE_VERSION__
    : undefined;
